import { FC } from "react"
import { Stack } from "@mui/material"
import { TextFieldElement } from "react-hook-form-mui"
import { RtkHookForm } from "@/core/components"
import { GuestBot } from "../../interfaces"
import { useCreateBotMutation } from "../../store"

interface IProps {
  onDone?: () => void
}
interface FormData {
  token: string
  delaySeconds: number
}

export const CreateGuestBotForm: FC<IProps> = ({ onDone }) => (
  <RtkHookForm<FormData, GuestBot.CreateBotRes>
    mutationHook={useCreateBotMutation as never}
    formContextParams={{ defaultValues: { token: "", delaySeconds: 0 } }}
    getSubmitHandlerParams={(data) => ({
      body: { token: data.token, delaySeconds: Number(data.delaySeconds) },
    })}
    afterSubmit={() => onDone?.()}
    successMessage="Бот добавлен"
    actions={[
      {
        text: "Добавить",
        type: "submit",
        variant: "contained",
        fullWidth: true,
      },
    ]}
  >
    <Stack spacing={2}>
      <TextFieldElement name="token" label="Токен бота" required fullWidth />
      <TextFieldElement
        name="delaySeconds"
        label="Задержка ответа (сек, 0–180)"
        type="number"
        fullWidth
        validation={{
          min: { value: 0, message: "Минимум 0" },
          max: { value: 180, message: "Максимум 180" },
        }}
      />
    </Stack>
  </RtkHookForm>
)
